import axios from "axios";
import { readCsrfCookie } from "../context/AuthContext";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const publicApi = axios.create({ baseURL: API, withCredentials: true });

function attachCsrf(instance) {
  instance.interceptors.request.use((config) => {
    const method = (config.method || "get").toLowerCase();
    if (["post", "put", "patch", "delete"].includes(method)) {
      const csrf = readCsrfCookie();
      if (csrf) config.headers["X-CSRF-Token"] = csrf;
    }
    return config;
  });
  return instance;
}

attachCsrf(publicApi);

export function useApi() {
  return publicApi;
}
